import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65d657cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-7 justify-start items-center p-10 gap-5 w-full" }
const _hoisted_2 = {
  key: 1,
  class: "flex lg:flex-row flex-col text-left justify-between col-span-7 lg:col-span-6"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left text-[16px] text-black" }, "Nombre", -1))
const _hoisted_4 = { class: "font text-left text-[16px] text-black" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left text-[16px] text-black" }, "Rut", -1))
const _hoisted_6 = { class: "font text-left text-[16px] text-black" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border border-3 block" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left text-[16px] text-black" }, " Correo electrónico ", -1))
const _hoisted_9 = { class: "font text-left text-[16px] text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.authStore.user)
      ? (_openBlock(), _createBlock(_component_mdicon, {
          key: 0,
          name: _ctx.authStore.user.identificationIconName,
          size: "80",
          class: "col-span-7 lg:col-span-1 bg-[#9BB441] text-white color-white w-[100px] h-[100px] rounded-full flex items-center justify-center"
        }, null, 8, ["name"]))
      : _createCommentVNode("", true),
    (_ctx.authStore.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.authStore.user.firstName) + " " + _toDisplayString(_ctx.authStore.user.lastName), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.formatRut(_ctx.authStore.user.rut)), 1)
          ]),
          _hoisted_7,
          _createElementVNode("div", null, [
            _hoisted_8,
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.authStore.user.email), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}